export default __webpack_public_path__ + "static/media/dice-background.5ebb5126.svg";